import { render, staticRenderFns } from "./CreateYourGiftModal.vue?vue&type=template&id=30d60876&scoped=true&"
import script from "./CreateYourGiftModal.vue?vue&type=script&lang=ts&"
export * from "./CreateYourGiftModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateYourGiftModal.vue?vue&type=style&index=0&id=30d60876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d60876",
  null
  
)

export default component.exports